import React from "react";

export function TextMessage({text}: ({ text: string })): React.ReactElement {

    return (
        <>
            <p>{text}</p>
        </>
    );
}

